import { render, staticRenderFns } from "./HomePart2.vue?vue&type=template&id=53f9f6f5&scoped=true&"
import script from "./HomePart2.vue?vue&type=script&lang=js&"
export * from "./HomePart2.vue?vue&type=script&lang=js&"
import style0 from "./HomePart2.vue?vue&type=style&index=0&id=53f9f6f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f9f6f5",
  null
  
)

export default component.exports